import {useQuery} from 'react-query';
import {CashPaymentResponse} from '../../../pages/shopping-basket/cash-payment/utils/types';
import {getStoreOrderCashTransactionPrice} from './getStoreOrderCashTransactionPrice';

const useGetStoreOrderCashTransactionPrice = ({
  storeOrderGuid,
  handleAfterSuccess,
  enabled = true,
}: {
  storeOrderGuid?: string;
  handleAfterSuccess?: (data: CashPaymentResponse) => void;
  enabled?: boolean;
}) => {
  const {data, isLoading, refetch, isSuccess, isFetching} =
    useQuery<CashPaymentResponse>(
      ['get-store-order-cash-transaction-price', storeOrderGuid],
      () => getStoreOrderCashTransactionPrice(storeOrderGuid),
      {
        enabled: Boolean(storeOrderGuid) && enabled,
        onSuccess: data => handleAfterSuccess?.(data),
      },
    );
  return {data, isLoading, refetch, isSuccess, isFetching};
};

export default useGetStoreOrderCashTransactionPrice;
